module.exports = __webpack_public_path__ + "01c4d6a3c661c9b5a4ac555b34ae9ad9.svg";